module.exports = __webpack_public_path__ + "img/outsourcing.68598c80.svg";